import {useState, useEffect} from 'react';

function formatDate(isoString) {
  const date = new Date(isoString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
}

const DeleteHeads = () => {
  // test barangay_codes
  // localStorage.setItem("barangayCode", "10649"); // bucal
  // localStorage.setItem("barangayCode", "10974"); // sabang
  const [activeTab, setActiveTab] = useState("request");
  const name = `${localStorage.getItem("userFirstName")} ${localStorage.getItem("userLastName")}`;
  const role = localStorage.getItem("userRole");;
  const barangayCode = localStorage.getItem("barangayCode");
  const userID = localStorage.getItem("userId");

  const [selectedHeads, setSelectedHeads] = useState([]);
  const [familyHeadsData, setFamilyHeadsData] = useState([]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showStatus, setShowStatus] = useState(false);
  const [messageStatus, setMessageStatus] = useState({})

  const [deleteRequests, setDeleteRequests] = useState([]);
  const [pendingRequests, setPendingRequests] = useState([]);
  const [completedRequests, setCompletedRequests] = useState([]);

  const [query, setQuery] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useState("");

  const [searchedData, setSearchedData] = useState([]);

  const fetchFamilyHeadsData = async () => {
      let baseUrl = `${process.env.REACT_APP_API_URL}/api/locations/api/family_head_data`
      try {
          const barangay_id = localStorage.getItem("barangayCode");
          const apiUrl = `${baseUrl}?barangay_id=${encodeURIComponent(barangayCode)}`;
          const response = await fetch(apiUrl, {
            method: 'GET',
            headers: {
                'x-api-key': process.env.REACT_APP_API_KEY
            }
          });
          const data = await response.json();
          if (Array.isArray(data) && data.length > 0) {
              setFamilyHeadsData(data);
              return data;
          } else {
              console.warn(`API returned an empty array or non-array data. Data received:`, data);
              // Default empty fetchedData if no data
          }
    } catch (error) {
      console.error(`Error fetching family heads data:`, error);
      // Default empty fetchedData on error
    }
  }

  const fetchDeleteRequests = async () => {
      let baseUrl = `${process.env.REACT_APP_API_URL}/api/locations/api/delete_requests`
      try {
          if (!barangayCode || !userID) {
            console.error('❌ Missing barangayCode or userID');
            return;
          }
          const apiUrl = `${baseUrl}?barangay_id=${encodeURIComponent(barangayCode)}&user_id=${encodeURIComponent(userID)}`;
          const response = await fetch(apiUrl, {
            method: 'GET',
            headers: {
                'x-api-key': process.env.REACT_APP_API_KEY
            }
          });
          const data = await response.json();
          if (Array.isArray(data) && data.length > 0) {
              setDeleteRequests(data);
              return data;
          } else {
              console.warn(`API returned an empty array or non-array data. Data received:`, data);
              // Default empty fetchedData if no data
          }
    } catch (error) {
      console.error(`Error fetching delete requests:`, error);
      // Default empty fetchedData on error
    }
  }

  useEffect(() => {
    const loadData = async () => {
      await loadDeleteRequests();
      await loadFamilyData();
    };

    const loadFamilyData = async () => {
      const data = await fetchFamilyHeadsData();
      const filteredFamilyData =
        Array.isArray(data) && Array.isArray(deleteRequests) && deleteRequests.length !== 0
          ? data.filter(fam =>
              !deleteRequests.some(req =>
                req.head_id === fam.head_id &&
                (req.status === 'pending' || req.status === 'approved')
              )
            )
          : data;
      setFamilyHeadsData(filteredFamilyData);
      setSearchedData(filteredFamilyData);
    };

    const loadDeleteRequests = async () => {
      const data = await fetchDeleteRequests();
      setDeleteRequests(data);
    }

    loadData();
  }, [activeTab])

  useEffect(() => {
    if (Array.isArray(deleteRequests) && deleteRequests.length !== 0) {
      const pendingRequests = deleteRequests.filter((item) => item.status === 'pending');
      const completedRequests = deleteRequests.filter((item) => (item.status === 'rejected' || item.status === 'approved'));

      setPendingRequests(pendingRequests);
      setCompletedRequests(completedRequests);
    }
  }, [deleteRequests]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(query)
    }, 500);

    return () => {
      clearTimeout(handler);
    }
  }, [query]);

  useEffect(() => {
    if (debouncedQuery.trim() === "") {
      setSearchedData(familyHeadsData);
      return;
    };

    const lowerSearch = debouncedQuery.toLowerCase();

    setSearchedData((Array.isArray(familyHeadsData) && familyHeadsData.length !== 0) ? familyHeadsData.filter((item) => {
      const idMatch = item.head_id.toString().includes(lowerSearch);
      const nameMatch = item.fullname.toLowerCase().includes(lowerSearch);
      return idMatch || nameMatch;
    }) : []);
    
  }, [debouncedQuery, familyHeadsData]);

  const handleCheckboxChange = (headId, headname) => {
    setSelectedHeads((prevSelected) => {
      const isSelected = prevSelected.some(item => item.head_id === headId);

      if (isSelected) {
        // If already selected → remove it
        return prevSelected.filter(item => item.head_id !== headId);
      } else {
        // If not selected → add it
        return [...prevSelected, { head_id: headId, headname }];
      }
    });
  };

  const confirmDelete = async () => {
    let baseUrl = `${process.env.REACT_APP_API_URL}/api/locations/api/delete_requests`
    const apiUrl = `${baseUrl}?barangay_code=${encodeURIComponent(barangayCode)}`
    const response = await fetch(apiUrl,
        {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_API_KEY
        },
        body: JSON.stringify({headsToDelete: selectedHeads, userId: userID, userName: name, userRole: role}),
        }
    );

    const result = await response.json();

    if (!response.ok) {
        console.error("Server error response:", result);
        throw new Error(result.message || `Failed to save data. Status: ${response.status}`);
    }
    setMessageStatus(result.status);
    setSelectedHeads([]);
    setActiveTab("pending");
    return(result)
  }

  // const filteredData = Array.isArray(deleteRequests) ? deleteRequests.filter((item) => {
  //   if (activeTab === "completed") return item.deletedAt;
  //   if (activeTab === "pending") return !item.deletedAt;
  //   return true;
  // }) : [];

  return (
    (barangayCode) ?
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        width: "60vw",
        alignItems: "center",
        margin: "50px auto",
        border: "2px solid #444",
        borderRadius: "10px",
        overflow: "hidden",
        backgroundColor: "#f9fafc",
        boxShadow: "0 3px 8px rgba(0,0,0,0.1)",
      }}
    >
      {/* Tabs */}
      <div
        style={{
          display: "flex",
          width: "100%",
          borderBottom: "2px solid #444",
        }}
      >
        {["request", "pending", "completed"].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            style={{
              flex: 1,
              border: "none",
              borderRight: "1px solid #444",
              padding: "12px 0",
              fontWeight: "600",
              fontSize: "16px",
              backgroundColor: activeTab === tab ? "#becdde" : "#e7ecf3",
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
          >
            {tab.charAt(0).toUpperCase() + tab.slice(1)}
          </button>
        ))}
      </div>

       <div
        style={{
          width: "90%",
          marginTop: "15px",
          marginBottom: "10px",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        {activeTab === "request" && <input
          type="text"
          placeholder="Search by ID or Name..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          style={{
            width: "50%",
            padding: "8px 12px",
            borderRadius: "8px",
            border: "1px solid #aaa",
            fontSize: "15px",
            outline: "none",
            transition: "0.2s",
          }}
          onFocus={(e) => (e.target.style.borderColor = "#555")}
          onBlur={(e) => (e.target.style.borderColor = "#aaa")}
        />}
      </div>

      {/* Data Container */}
      <div
        style={{
          width: "100%",
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          maxHeight: "50vh",
          overflowY: "auto",
        }}
      >
        {(activeTab === "request" && searchedData !== undefined) && searchedData.map((head) => {
          return (
            <div
              key={head.head_id}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "#f1f3f8",
                borderRadius: "8px",
                padding: "10px 15px",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                marginBottom: "10px",
              }}
            >
              <div style={{ width: "15%", fontWeight: "600", textAlign: "center" }}>
                {head.head_id}
              </div>
              <div style={{ width: "60%", fontWeight: "500", color: "#333" }}>
                {head.fullname}
              </div>

              <input
                type="checkbox"
                checked={selectedHeads.some(item => item.head_id === head.head_id)}
                onChange={() => handleCheckboxChange(head.head_id, head.fullname)}
                style={{ transform: "scale(1.2)", cursor: "pointer" }}
              />
            </div>
          );
        })}
        {(activeTab === "pending") && pendingRequests.map((head) => {
          return (
            <div
              key={head.head_id}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "#f1f3f8",
                borderRadius: "8px",
                padding: "10px 15px",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                marginBottom: "10px",
              }}
            >
              <div style={{ width: "15%", fontWeight: "600", textAlign: "center" }}>
                {head.head_id}
              </div>
              <div style={{ width: "60%", fontWeight: "500", color: "#333" }}>
                {head.headname}
              </div>
              <div style={{ width: "25%", textAlign: "center", color: "#666" }}>
                {formatDate(head.requested_at) || "-"}
              </div>
            </div>
          );
        })}
        {(activeTab === "completed") && completedRequests.map((head) => {
          return (
            <div
              key={head.head_id}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "#f1f3f8",
                borderRadius: "8px",
                padding: "10px 15px",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                marginBottom: "10px",
              }}
            >
              <div style={{ width: "15%", fontWeight: "600", textAlign: "center" }}>
                {head.head_id}
              </div>
              <div style={{ width: "60%", fontWeight: "500", color: "#333" }}>
                {head.headname}
              </div>
              <div style={{ width: "25%", textAlign: "center", color: "#666" }}>
                {head.status.toUpperCase() || "-"}
              </div>
            </div>
          );
        })}

        {((activeTab === 'request' && Array.isArray(searchedData) && searchedData.length === 0) || (activeTab === 'pending' && pendingRequests.length === 0) || (activeTab === 'completed' && completedRequests.length === 0)) && (
          <div
            style={{
              textAlign: "center",
              color: "#777",
              marginTop: "20px",
              fontStyle: "italic",
            }}
          >
            No records to display
          </div>
        )}
      </div>

      {/* Summary for request tab */}
      {activeTab === "request" && (
        <div
          style={{
            margin: "20px 0",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {selectedHeads.length > 0 ? (
            <button
              onClick={() => setShowConfirm(true)}
              style={{
                backgroundColor: "#d9534f",
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                padding: "10px 18px",
                fontWeight: "600",
                fontSize: "15px",
                cursor: "pointer",
                transition: "background-color 0.2s ease",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = "#c9302c")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = "#d9534f")
              }
            >
              Request Deletion ({selectedHeads.length})
            </button>
          ) : (
            <div style={{ color: "#777", fontStyle: "italic" }}>
              No family head selected
            </div>
          )}
        </div>
      )}
      {showConfirm && (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: "1000",
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              padding: "20px 30px",
              borderRadius: "12px",
              textAlign: "center",
              boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
              minWidth: "300px",
            }}
          >
            <h3 style={{ marginBottom: "15px", color: "#333" }}>
              Confirm Deletion
            </h3>
            <p style={{ marginBottom: "20px", color: "#555" }}>
              {`Request to delete ${selectedHeads.length} family head(s)?`}
            </p>
            <div style={{ display: "flex", justifyContent: "space-around" }}>
              <button
                onClick={() => setShowConfirm(false)}
                style={{
                  padding: "8px 16px",
                  borderRadius: "8px",
                  border: "none",
                  backgroundColor: "#ccc",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
              <button
                onClick={async () => {
                  await confirmDelete();
                  setShowConfirm(false);
                  setShowStatus(true);
                }}
                style={{
                  padding: "8px 16px",
                  borderRadius: "8px",
                  border: "none",
                  backgroundColor: "#e74c3c",
                  color: "#fff",
                  cursor: "pointer",
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
      {showStatus && (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: "1000",
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              padding: "24px 36px",
              borderRadius: "16px",
              textAlign: "center",
              boxShadow: "0 8px 20px rgba(0,0,0,0.25)",
              minWidth: "340px",
              maxWidth: "400px",
              animation: "fadeIn 0.25s ease-in-out",
            }}
          >
            <h3
              style={{
                marginBottom: "16px",
                color: "#222",
                fontSize: "1.4rem",
                fontWeight: "600",
              }}
            >
              Status Summary
            </h3>

            <p style={{ color: "#444", marginBottom: "10px" }}>
              Attempted to create <strong>{messageStatus.totalRows}</strong> delete requests.
            </p>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "#f9f9f9",
                padding: "12px 18px",
                borderRadius: "10px",
                marginBottom: "12px",
              }}
            >
              <span style={{ color: "#555", fontWeight: "500" }}>Successful:</span>
              <span style={{ color: "#16a34a", fontWeight: "700" }}>
                {messageStatus.successCount}
              </span>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "#f9f9f9",
                padding: "12px 18px",
                borderRadius: "10px",
                marginBottom: "20px",
              }}
            >
              <span style={{ color: "#555", fontWeight: "500" }}>Failed:</span>
              <span style={{ color: "#dc2626", fontWeight: "700" }}>
                {messageStatus.failCount}
              </span>
            </div>

            <div style={{ display: "flex", justifyContent: "center" }}>
              <button
                onClick={() => setShowStatus(false)}
                style={{
                  padding: "10px 22px",
                  borderRadius: "10px",
                  border: "none",
                  backgroundColor: "#2563eb",
                  color: "#fff",
                  cursor: "pointer",
                  fontWeight: "500",
                  fontSize: "0.95rem",
                  transition: "background-color 0.2s ease",
                }}
                onMouseOver={(e) => (e.target.style.backgroundColor = "#1d4ed8")}
                onMouseOut={(e) => (e.target.style.backgroundColor = "#2563eb")}
              >
                Okay
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
    :
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        width: "60vw",
        alignItems: "center",
        margin: "50px auto",
        border: "2px solid #444",
        borderRadius: "10px",
        overflow: "hidden",
        backgroundColor: "#e74848ff",
        boxShadow: "0 3px 8px rgba(0,0,0,0.1)",
      }}
    >
      <span style={{padding: "10px", fontWeight: "bold"}}>Error: Barangay Code is not Found</span>
    </div>
  );
}

export default DeleteHeads